/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewMenuItemModifierDto as DigiworkMaitreDPosDtoMenuItemModifiersNewMenuItemModifierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItemModifiers/new-menu-item-modifier-dto';
import { MenuItemDto as DigiworkMaitreDPosDtoMenuItemsMenuItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-item-dto';

export interface AddMenuItem$Params {
      body?: {
'Name'?: string;
'ImageFile'?: Blob;
'MenuCategoryId'?: string;
'MenuSubcategoryId'?: string;
'Price'?: number;
'TaxRateId'?: string;
'ItemIngredients'?: string;
'ItemModifiers'?: Array<DigiworkMaitreDPosDtoMenuItemModifiersNewMenuItemModifierDto>;
}
}

export function addMenuItem(http: HttpClient, rootUrl: string, params?: AddMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>> {
  const rb = new RequestBuilder(rootUrl, addMenuItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>;
    })
  );
}

addMenuItem.PATH = '/api/menu-categories/menu-items';
